import React from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import { motion } from 'framer-motion'

import card from '../../../assets/images/card.svg'
import Footnote from '../../../components/footnote/Footnote'
import { redirect } from '../../../utils/helpers'
import Paths from '../../../utils/paths'
import useStyles from '../PayrollCards.styles'

const PLATFORM_LOGIN = 'https://platform.accesswages.com/login'

export default function PayroCardsProgram () {
  const classes = useStyles()
  const navigate = useNavigate()

  return (
    <div className={classes.programContainer}>
      <div className={classes.programRow}>
        <div className={classes.programTextContainer}>
          <h2 className={classes.programTitle}>Our payroll card program gives you a seamless, paperless solution for employee payments—no bank account required. Our paycards are simple to set up and easy to use.</h2>
        </div>
        <div className={classes.programCardContainer}>
          <motion.img
            alt='Card'
            src={card}
            initial={{ scale: 0.1 }}
            whileInView={{ scale: 1 }}
            transition={{ duration: 0.5 }}
            />
        </div>
      </div>
      <Footnote 
        color='white'
        notes={[
          'The Multikrd Payroll Mastercard is issued by Central Bank of Kansas City, Member FDIC, pursuant to a license by Mastercard International Incorporated. Mastercard is a registered trademark, and the circles design is a trademark of Mastercard International Incorporated. Certain fees, terms, and conditions are associated with the approval, maintenance, and use of the Card. You should consult your Cardholder Agreement and Fee Schedule.',
          'If you have any questions regarding the Card or such fees, terms, and conditions, you can contact us toll-free at 1-866-995-2736, we are available 24/7/365.'
        ]} 
      />
    </div>
  )
}
